export default __webpack_public_path__ + "static/media/154.92d49344.png";